/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Defines a real world address
 */
export interface AddressDataDTO { 
    /**
     * Street name
     */
    street?: string;
    /**
     * House number
     */
    houseNumber?: string;
    /**
     * Address postal (zip) code
     */
    postalCode?: string;
    /**
     * City of address
     */
    city?: string;
    /**
     * Country code of address
     */
    countryCode?: string;
    /**
     * (Federal) State of address
     */
    state?: string;
    /**
     * Additional address information  The length requirements is going to be applied soon - minimum: 1, maximum: 46. 
     */
    additionalData?: string;
}

export class ClsAddressDataDTO { 
    /**
     * Street name
     */
    street?: string = undefined;
    /**
     * House number
     */
    houseNumber?: string = undefined;
    /**
     * Address postal (zip) code
     */
    postalCode?: string = undefined;
    /**
     * City of address
     */
    city?: string = undefined;
    /**
     * Country code of address
     */
    countryCode?: string = undefined;
    /**
     * (Federal) State of address
     */
    state?: string = undefined;
    /**
     * Additional address information  The length requirements is going to be applied soon - minimum: 1, maximum: 46. 
     */
    additionalData?: string = undefined;
}

